import { useState } from 'react';

import { Box } from '@material-ui/core';
import { Product } from '@setvi/shared/interfaces';
import { SButton } from '@setvi/shared/components';
import { AnalyticsModules, useAnalytics } from '@setvi/shared/hooks';
import { CheckIconV2 } from '@setvi/shared/components/sicons';

import Products from 'pages/products';
import { RealmProvider } from 'Providers/MongoRealmProvider';

import { useParams } from 'react-router-dom';
import { Footer } from './styled';

export interface CatalogProps {
  product?: Product;
  onClose?: () => void;
  handleSubmit: (product: Product) => void;
}

const Catalog = ({ product, handleSubmit, onClose }: CatalogProps) => {
  const { id } = useParams();

  const { captureAnalytics } = useAnalytics();
  const [exported, setExported] = useState(product || null);

  return (
    <RealmProvider>
      <Box
        width="100%"
        height="100%"
        flexDirection="column"
        display="flex"
        justifyContent="space-between">
        <Products
          mode="embedded"
          type="radio"
          selectedProducts={[exported]}
          handleExport={(p: Product[]) => {
            if (p?.[0]) setExported(p?.[0]);
          }}
        />

        <Footer>
          <SButton
            color="default"
            variant="text"
            onClick={onClose}
            style={{
              borderRadius: 36,
              color: '#5D7083'
            }}>
            Cancel
          </SButton>

          <SButton
            disabled={!exported}
            tooltipTitle={!exported ? 'Please select item' : ''}
            onClick={() => {
              handleSubmit(exported);

              const sourceIsPL =
                product?.isPrivateLabel || product?.privateLabel;
              const targetIsPL =
                exported?.isPrivateLabel || exported?.privateLabel;

              captureAnalytics(
                {
                  action: 'catalog',
                  id: exported?._id,
                  rfqId: id || '',
                  sourceProductId: product?.sku || '',
                  targetProductId: exported?.sku || '',
                  sourceIsPL,
                  targetIsPL
                },
                AnalyticsModules.AutoRFQItem
              );
            }}
            endIcon={
              <CheckIconV2
                style={{
                  width: 20,
                  height: 20,
                  marginBottom: 2
                }}
              />
            }
            style={{
              borderRadius: 36
            }}>
            Select Item
          </SButton>
        </Footer>
      </Box>
    </RealmProvider>
  );
};

export default Catalog;
